<div class="container">
  <div class="home-view">
    <div class="home-content">
      <h3 class="know-expenses">Know and manage expenses easily.</h3>
      <div class="content-container">
        <h1 class="content-head">
          <span class="content-sub">Add, Share, Track and Manage</span>
          <span> your cash in piece.</span>
        </h1>
      </div>
      <p class="content-description">Manage and keep track on the balances and shared spending for trips, groups, friends, and family.</p>
    </div>
    <div class="steps">
      <div class="steps-container">
        @for (step of steps; track step) {
          <div class="step">
            <h4 class="step-index">{{step.index}}</h4>
            <h2 class="step-head">{{step.name}}</h2>
            <p class="step-description">{{step.description}}</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>